// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiProfileWave {
    'profile_wave_id': string | null;
    'profile_curation_id': string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "profile_wave_id",
            "baseName": "profile_wave_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "profile_curation_id",
            "baseName": "profile_curation_id",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiProfileWave.attributeTypeMap;
    }

    public constructor() {
    }
}

